/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slimy_Real_Ox_AdoreInputs */

const fr_slimy_real_ox_adore = /** @type {(inputs: Slimy_Real_Ox_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des drop-ins`)
};

/**

* @param {Slimy_Real_Ox_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slimy_real_ox_adore = /** @type {((inputs?: Slimy_Real_Ox_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slimy_Real_Ox_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slimy_real_ox_adore(inputs)
});